"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithSession = exports.withSession = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var SessionContext_1 = require("../contexts/SessionContext");
var errors_1 = require("../errors");
var withSession = function withSession(Component, displayName) {
  displayName = displayName || Component.displayName || Component.name || 'Component';
  Component.displayName = displayName;
  var HOC = function HOC(props) {
    var session = (0, SessionContext_1.useSessionContext)();
    if (!session) {
      return null;
    }
    return react_1.default.createElement(Component, Object.assign({}, props, {
      session: session
    }));
  };
  HOC.displayName = "withSession(".concat(displayName, ")");
  return HOC;
};
exports.withSession = withSession;
var WithSession = function WithSession(_ref) {
  var children = _ref.children;
  var session = (0, SessionContext_1.useSessionContext)();
  if (typeof children !== 'function') {
    throw new Error(errors_1.hocChildrenNotAFunctionError);
  }
  if (!session) {
    return null;
  }
  return react_1.default.createElement(react_1.default.Fragment, null, children(session));
};
exports.WithSession = WithSession;